import axios, { AxiosInstance } from 'axios';
import { getBaseURL } from '@/utils/request';

// 创建独立的 axios 实例（登录接口专用，不携带 token、401 不跳登录页、不弹业务错误）
const authRequest: AxiosInstance = axios.create({
    baseURL: getBaseURL(),
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
});

// 响应拦截器（只处理响应格式，不做 401 跳转、不弹 ElMessage）
authRequest.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (res.code === 0 || res.code === 200) {
            return res.data;
        } else {
            return Promise.reject(new Error(res.msg || '请求失败'));
        }
    },
    (error) => {
        return Promise.reject(error);
    },
);

// ==================== 类型定义 ====================

/**
 * 登录请求参数
 */
export interface LoginDTO {
    username: string;
    password: string;
}

/**
 * 登录响应数据
 */
export interface LoginVO {
    token: string;
    adminId: number;
    username: string;
    realName: string;
    phone: string;
    email: string;
}

// ==================== 认证接口 ====================

/**
 * 管理员登录
 */
export const login = (data: LoginDTO) => {
    return authRequest.post<any, LoginVO>('/admin/login', data);
};

/**
 * 检查是否已登录
 */
export const isLoggedIn = (): boolean => {
    const token = localStorage.getItem('token');
    return !!token;
};

/**
 * 退出登录
 */
export const logout = async () => {
    try {
        const token = localStorage.getItem('token');
        if (token) {
            await authRequest.post('/admin/logout', null, {
                headers: { Authorization: `Bearer ${token}` },
            });
        }
    } catch {
        // 即使后端调用失败也继续清除本地状态
    }
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    // 同步清空角色缓存，避免下次登录前残留
    try {
        const { clearRoleCodes } = await import('@/utils/permissions');
        clearRoleCodes();
    } catch {
        // 忽略导入失败
    }
};

export default authRequest;
